import { Delta } from 'quill/core';

const deltaToText = (content: Delta | Delta['ops']) => {
  const delta = new Delta(content);
  return delta
    .map((op) => {
      if (typeof op.insert === 'string') {
        return op.insert;
      }
      return op.attributes?.content || '';
    })
    .join('');
};

export default deltaToText;
